<template>
    <div class="footer-button">
        <button class="button button--primary button--full-width" @click="confirmData" :disabled="isDisabled">
                {{ textPrimaryButton }}
        </button>

        <button type="button" class="button button--text-button"  @click="confirmDataSecondary" v-if="secondaryButton">
            Voltar
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            secondaryButton: {
                type: Boolean,
                required: false,
                default: false
            },
            confirmData: {
                type: Function,
                required: false
            },
            confirmDataSecondary: {
                type: Function,
                required: false
            },
            isDisabled: {
                type: Boolean,
                required: false,
                default: false
            },
            textPrimaryButton: {
                type: String,
                required: false,
                default: 'Continuar'
            }
        },
        methods: {
            primaryActionComponent(){
                this.confirmData()
                this.confirmDataSecondary()
            }
        }
    }
</script>

<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .footer-button{
        width:  100%;
        display: flex;
        flex-direction: column;
        align-self: center;
        align-items: center;
        justify-content: center;
        padding: 1.5rem 1.5rem 2.125rem 1.5rem;
        box-shadow  : 0px -5px 5px 0px #0000001A;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: white;
        gap: 16px;

        @include breakpoint('medium') {
            box-shadow: none;
        }

        @include breakpoint('large') {
            box-shadow: none;

        }
    }

    .footer-button a{
        color: $color-card-dark;
        font-size: 16px;
        font-weight: 500;

        @include breakpoint('medium') {
            width: 90%;
        }

        @include breakpoint('large') {
            box-shadow: none;
            width: 70%;

        }
    }

    .button--text-button{
        color: #435254;
        font-weight: 500;
    }

    .button:disabled{
        opacity: 40%;
    }
</style>
